import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = {
  list: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalRows: 0,
  },
  data: {
    active: true,
  },
  isFetchingList: false,
  isModalActive: false,
  isModalLoading: false,
  modalHeader: '',
  viewMode: true,
};

export function itemUomReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_ITEM_UOM: {
      let result = {
        ...state,
        data: { ...action.data },
      };

      return result;
    }

    case ActionType.CLEAR_ITEM_UOM: {
      const initialState = { ...INITIAL_STATE };
      delete initialState.data;
      return {
        ...state,
        ...initialState,
        list: state.list,
      };
    }

    case ActionType.OPEN_ITEM_UOM_MODAL: {
      return {
        ...state,
        isModalActive: true,
      };
    }

    case ActionType.CLOSE_ITEM_UOM_MODAL: {
      return {
        ...state,
        isModalActive: false,
      };
    }

    case ActionType.VIEW_ITEM_UOM_MODAL: {
      return {
        ...state,
        viewMode: true,
      };
    }

    case ActionType.EDIT_ITEM_UOM_MODAL: {
      return {
        ...state,
        viewMode: false,
      };
    }

    case ActionType.SET_ITEM_UOM_LIST: {
      return {
        ...state,
        list: action.list,
        isFetchingList: false,
      };
    }

    case ActionType.GET_ITEM_UOM_LIST_IN_PROGRESS: {
      return {
        ...state,
        isFetchingList: true,
      };
    }

    case ActionType.SET_MODAL_LOADING: {
      return {
        ...state,
        isModalLoading: action.loading,
      };
    }

    case ActionType.SET_ITEM_UOMS_PAGINATION: {
      let newState = { ...state };
      if (action.page) newState.pagination.page = action.page;
      if (action.perPage) newState.pagination.perPage = action.perPage;
      if (action.totalRows >= 0)
        newState.pagination.totalRows = action.totalRows || 0;
      return newState;
    }

    default:
      return state;
  }
}
